import { REQUEST_CITIES, RECEIVE_CITIES } from '../constants';
import { checkStatus, handleRequestError } from '../utils/helpers';
import config from '../../config';
import bayAreaShops from '../applicationServices/bayAreaShops';

export function requestCities() {
  return {
    type: REQUEST_CITIES,
  };
}

export function receiveCities(cities) {
  return {
    type: RECEIVE_CITIES,
    payload: cities,
  };
}

function shouldFetchCities(state) {
  if (!state.cities.items.length) {
    return true;
  } else if (state.isFetching) {
    return false;
  }
  return true;
}

export function fetchAllCities() {
  return (dispatch, getState) => {
    if (!shouldFetchCities(getState())) return Promise.resolve();

    dispatch(requestCities());

    return fetch(`${config.url}/shop/cities`)
      .then(checkStatus)
      .then(bayAreaShops.fetchCities)
      .then(cities => dispatch(receiveCities(cities)))
      .catch(handleRequestError(dispatch));
  };
}



// WEBPACK FOOTER //
// ./src/app/cities/actions.js